// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"880":"b52efe20","972":"fa354834"}[chunkId] + ".chunk.css";
};